"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Graphics = require("../../graphics");

var chart_element_1 = require("../chart_element");

var PlotSegmentClass =
/*#__PURE__*/
function (_chart_element_1$Char) {
  _inherits(PlotSegmentClass, _chart_element_1$Char);

  function PlotSegmentClass() {
    _classCallCheck(this, PlotSegmentClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlotSegmentClass).apply(this, arguments));
  }

  _createClass(PlotSegmentClass, [{
    key: "initializeState",

    /** Fill the layout's default state */
    value: function initializeState() {}
    /** Build intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles) */

  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver, context) {}
    /** Build constraints for glyphs within */

  }, {
    key: "buildGlyphConstraints",
    value: function buildGlyphConstraints(solver, context) {}
    /** Get the graphics that represent this layout */

  }, {
    key: "getPlotSegmentGraphics",
    value: function getPlotSegmentGraphics(glyphGraphics, manager) {
      return Graphics.makeGroup([glyphGraphics, this.getGraphics(manager)]);
    }
  }, {
    key: "getCoordinateSystem",
    value: function getCoordinateSystem() {
      return new Graphics.CartesianCoordinates();
    }
    /** Get DropZones given current state */

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      return [];
    }
    /** Get handles given current state */

  }, {
    key: "getHandles",
    value: function getHandles() {
      return null;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      return null;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.row("Data", manager.horizontal([0, 1], manager.filterEditor({
        table: this.object.table,
        target: {
          plotSegment: this.object
        },
        value: this.object.filter,
        mode: "button"
      }), manager.groupByEditor({
        table: this.object.table,
        target: {
          plotSegment: this.object
        },
        value: this.object.groupBy,
        mode: "button"
      })))];
    }
  }], [{
    key: "createDefault",
    value: function createDefault(glyph) {
      var plotSegment = _get(_getPrototypeOf(PlotSegmentClass), "createDefault", this).call(this);

      plotSegment.glyph = glyph._id;
      plotSegment.table = glyph.table;
      return plotSegment;
    }
  }]);

  return PlotSegmentClass;
}(chart_element_1.ChartElementClass);

exports.PlotSegmentClass = PlotSegmentClass;